export default __webpack_public_path__ + "static/media/settlement_empty.5174e89d.png";